import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Toggle, ImageField } from "./AdminUI";
import { Plus, Edit2, Trash2 } from "lucide-react";

const EMPTY = { name: "", logo_url: "", website: "", active: true, order: 0 };

export default function PartnersAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/partners/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!editing.name.trim()) return alert("Name required");
    if (editing.id) await api.put(`/partners/admin/${editing.id}`, editing);
    else await api.post("/partners/admin", editing);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete partner?")) { await api.delete(`/partners/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Partners / Brands <span className="text-muted text-base">({items.length})</span></h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-partner-btn"><Plus size={16} /> Add Partner</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((p) => (
          <div key={p.id} className="rounded-xl2 bg-white border border-line p-4 text-center">
            <div className="h-16 flex items-center justify-center">{p.logo_url ? <img src={p.logo_url} alt={p.name} className="max-h-14 object-contain" /> : <span className="font-extrabold text-ink/70">{p.name}</span>}</div>
            <div className="text-sm font-semibold text-ink mt-2">{p.name}</div>
            {!p.active && <span className="text-[10px] bg-ink/80 text-white px-2 py-0.5 rounded-full">Hidden</span>}
            <div className="flex gap-2 mt-3 justify-center"><Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...p })}><Edit2 size={14} /></Btn><Btn variant="danger" onClick={() => del(p.id)}><Trash2 size={14} /></Btn></div>
          </div>
        ))}
      </div>
      {editing && (
        <Modal title={editing.id ? "Edit Partner" : "Add Partner"} onClose={() => setEditing(null)}>
          <div className="space-y-4">
            <Input label="Brand Name *" value={editing.name} onChange={(v) => setF("name", v)} />
            <ImageField label="Logo (transparent PNG preferred)" value={editing.logo_url} onChange={(v) => setF("logo_url", v)} folder="gnons/settings/" />
            <Input label="Website URL (optional)" value={editing.website} onChange={(v) => setF("website", v)} />
            <Input label="Display Order" type="number" value={editing.order} onChange={(v) => setF("order", parseInt(v) || 0)} />
            <Toggle label="Active (visible on site)" checked={editing.active} onChange={(v) => setF("active", v)} />
          </div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-partner-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
